import { CLOSE_PRODUCT_MODAL } from "./types";

export default () => {
    return { type: CLOSE_PRODUCT_MODAL, payload: null, };
};
